import { useState } from "react";
import { OverlayViewF } from "@react-google-maps/api";
import HighlightedPropertyBoxMobile from "@template/Search/HighlightedPropertyBoxMobile";
import { PropertyDataV2 } from "commonModule/services/common";
import { CountApiListOfAllProperties } from "commonModule/services/search";
import DotMarker from "components/ListingMap/dots-section/DotMarker";
import { useAppSelector } from "stores/hooks";
import { selectOpenedPropertyCardInMapBox } from "stores/ui/uiSlice";
const PropertyDots = ({
  propertyListWithLatLng
}: {
  propertyListWithLatLng: CountApiListOfAllProperties[];
}) => {
  const openedPropertyCardId = useAppSelector(selectOpenedPropertyCardInMapBox);
  const [propertyData, setPropertyData] = useState<PropertyDataV2 | null>(null); // Initial state is null
  const getPropertyData = (data: PropertyDataV2) => {
    setPropertyData(data);
  };
  return <>
      {propertyListWithLatLng && propertyListWithLatLng.map(property => <OverlayViewF key={`${property.id}`} mapPaneName={"overlayMouseTarget"} position={{
      lat: property.latitude,
      lng: property.longitude
    }} zIndex={property.id === openedPropertyCardId ? 10 : 1}>
            <DotMarker property={property} getPropertyData={getPropertyData}
      // If the opened property has more than one unit, mark it as multi-unit
      hasMultiple={property.id === openedPropertyCardId ? property?.count > 1 : false} />
          </OverlayViewF>)}
      {openedPropertyCardId && propertyData && openedPropertyCardId === propertyData._id && <HighlightedPropertyBoxMobile properties={[propertyData]} propertyListWithLatLng={propertyListWithLatLng} />}
    </>;
};
export default PropertyDots;